import { registerSolidIconLibraries } from './app/common/iconLibrary';
import { LOG } from './app/common/util/log';
import { loglevel } from './environments/environment';
import { EXTERNAL_STYLES, externalStyles, GLOBAL_STYLES } from './styles';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { EnvironmentProviders, importProvidersFrom, Provider } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import '@solid-design-system/components/dist-versioned';
import { OAuthProviders } from '@utils/AuthenticationService';
import { OAuth2AuthInterceptorProvider } from '@utils/oauth2-auth.interceptor';
import { XsrfInterceptorProvider } from './app/common/interceptors/xsrf.interceptor';
import { apiConfigFactory } from './app/common/util/open-api-provider';
import { AdminViewComponent } from './app/views/admin-view/admin-view.component';
import { envAdmin } from './environments/environment-admin';
import { ApiModule, BASE_PATH } from './openapi-client';
import { TranslocoRootModule } from './transloco-root.module';
import { provideRouter, Routes } from '@angular/router';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

LOG.level = loglevel;

/**
 * styles from styles.ts is only available in builds, so for the demo the style has to be read from the referenced stylesheet.
 */
function getGlobalStyles(): string {
  const globalStyleElement: Element | null = document.head.querySelector('link[href="styles.css"]');
  const globalStyleSheet: CSSStyleSheet | undefined = [...document.styleSheets].find(
    sheet => sheet.ownerNode === globalStyleElement
  );
  return [...globalStyleSheet!.cssRules].map(rule => rule.cssText).join('');
}

function injectExternalStyles(): void {
  for (const externalStyle of externalStyles) {
    const style: HTMLLinkElement = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = externalStyle;
    document.head.appendChild(style);
  }
}

export const AdminOpenApiPathProvider: Provider | EnvironmentProviders = {
  provide: BASE_PATH,
  useValue: envAdmin.basePath,
};

const routes: Routes = [
  { path: '', component: AdminViewComponent },
  { path: 'oauth2/callback', component: AdminViewComponent },
  { path: '**', redirectTo: '/' },
];

(async function () {
  try {
    injectExternalStyles();
    registerSolidIconLibraries();
    await bootstrapApplication(AdminViewComponent, {
      providers: [
        { provide: GLOBAL_STYLES, useValue: getGlobalStyles() },
        { provide: EXTERNAL_STYLES, useValue: externalStyles },
        provideHttpClient(withInterceptorsFromDi()),
        importProvidersFrom(TranslocoRootModule),
        importProvidersFrom(ApiModule.forRoot(apiConfigFactory)),
        OAuth2AuthInterceptorProvider,
        XsrfInterceptorProvider,
        ...OAuthProviders,
        AdminOpenApiPathProvider,
        provideRouter(routes),
      ],
    });
  } catch (err) {
    console.error(err);
  }
})();

const appInsights = new ApplicationInsights({
  config: {
    connectionString: envAdmin.logging.connectionString,
  },
});
appInsights.loadAppInsights();
appInsights.trackPageView();
